/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useTheme, SvgCloseSmall } from '../utils/index.js';
import { IconButton } from '../Buttons/index.js';
/**
 * Tag for showing categories, filters etc.
 * @example
 * <Tag onRemove={() => alert('Closed a tag!')}>I'm a tag</Tag>
 * <Tag variant='basic'>Basic tag</Tag>
 */
export const Tag = (props) => {
    const { className, variant = 'default', children, onRemove, ...rest } = props;
    useTheme();
    return (React.createElement("span", { className: cx({
            'iui-tag-basic': variant === 'basic',
            'iui-tag': variant === 'default',
        }, className), ...rest },
        variant === 'default' ? (React.createElement("span", { className: 'iui-tag-label' }, children)) : (children),
        onRemove && (React.createElement(IconButton, { styleType: 'borderless', size: 'small', onClick: onRemove, "aria-label": 'Delete tag', className: 'iui-tag-button' },
            React.createElement(SvgCloseSmall, { "aria-hidden": true })))));
};
export default Tag;
